/* ===========================================================================
   LICHTJESDORP — interacties + Shopify cart
   Chrome (header, drawers, footer) wordt door Liquid gerenderd; dit bestand
   verzorgt: mega menu, cart drawer (AJAX Cart API), zoek-overlay (predictive
   search), accordions, tabs, productgalerij, varianten, qty, recent bekeken.
   Configuratie komt uit window.LD (gezet in layout/theme.liquid).
   =========================================================================== */
(function () {
  "use strict";

  const LD = window.LD || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ── Geld ─────────────────────────────────────────────────────── */
  function money(cents) {
    const n = (cents / 100).toLocaleString(LD.locale || "nl-NL", {
      style: "currency",
      currency: LD.currency || "EUR",
    });
    return n.replace(/,00(\s|$)/, ",-$1");
  }

  /* ── Scrim / drawers ──────────────────────────────────────────── */
  function showScrim(on) {
    const anyOpen = on
      || $("[data-cart]")?.classList.contains("show")
      || $("[data-mobile]")?.classList.contains("show")
      || $("[data-filter-panel]")?.classList.contains("show");
    $("[data-scrim]")?.classList.toggle("show", !!anyOpen);
    // Zonder dit scrolt de pagina onder een open drawer door: je veegt door
    // de collectie terwijl je dacht in de filterlijst te scrollen. De CSS
    // beperkt het slot tot schermen waar een drawer bestaat.
    document.documentElement.classList.toggle("is-locked", !!anyOpen);
  }
  function openCart() { $("[data-cart]")?.classList.add("show"); showScrim(true); }
  function closeCart() { wisCartMelding(); $("[data-cart]")?.classList.remove("show"); showScrim(false); }

  function toggleFilters(on) {
    const panel = $("[data-filter-panel]");
    if (!panel) return;
    const open = on === undefined ? !panel.classList.contains("show") : !!on;
    panel.classList.toggle("show", open);
    $$("[data-filter-toggle]").forEach((b) => b.setAttribute("aria-expanded", String(open)));
    showScrim(open);
  }

  /* ── Cart (Shopify AJAX API) ──────────────────────────────────── */
  // De laatst opgehaalde winkelwagen. De productpagina moet weten wat er al
  // in ligt om te kunnen zeggen hoeveel er nog bij kan: vijf op voorraad met
  // twee in het mandje is nog drie, niet vijf.
  let cartNu = null;

  async function fetchCart() {
    const res = await fetch((LD.routes?.cart_url || "/cart") + ".js");
    return res.json();
  }

  function aantalInCart(variantId) {
    if (!cartNu) return 0;
    return cartNu.items
      .filter((i) => i.variant_id === variantId)
      .reduce((n, i) => n + i.quantity, 0);
  }

  async function addToCart(items) {
    const res = await fetch((LD.routes?.cart_add_url || "/cart/add") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) {
      // Shopify weigert een toevoeging in zijn geheel als er te veel wordt
      // gevraagd, en meldt dat in de taal van de winkel — die hier op Engels
      // staat. Vandaar een eigen tekst; de winkelwagen laat daarna zien wat
      // er wél in ligt.
      const err = await res.json().catch(() => ({}));
      await refreshCart();
      const e = new Error(err.description || "Toevoegen is niet gelukt.");
      e.voorraad = res.status === 422;
      throw e;
    }
    await refreshCart();
    openCart();
  }

  // Shopify knijpt een te hoog aantal af naar wat er op voorraad is, en
  // meldt dat met een 422 terwijl de wijziging wél is doorgevoerd. Die
  // melding is niet machineleesbaar, dus we vergelijken zelf wat we vroegen
  // met wat er in het mandje staat. De regel zoeken we op zijn key en niet
  // op zijn plek in de lijst: bij een verwijderde regel schuift die plek op.
  async function changeLine(line, quantity) {
    const key = cartNu?.items?.[line - 1]?.key;
    const res = await fetch((LD.routes?.cart_change_url || "/cart/change") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line, quantity }),
    });
    const cart = res.ok ? await res.json() : await fetchCart();
    renderCart(cart);
    if (quantity > 0 && key) {
      const item = cart.items.find((i) => i.key === key);
      if (item && item.quantity < quantity) {
        const stuks = item.quantity === 1 ? "1 stuk" : `${item.quantity} stuks`;
        meldInCart(`Meer dan ${stuks} van ${item.product_title} is niet op voorraad.`);
      }
    }
    return cart;
  }

  /* Meldingen in de winkelwagen-drawer. Een alert() valt buiten de winkel
     en zegt niet waar het over gaat; deze regel staat boven de regels waar
     het misging. */
  function meldInCart(tekst) {
    const box = $("[data-cart-melding]");
    if (!box) { alert(tekst); return; }
    box.textContent = tekst;
    box.hidden = false;
    clearTimeout(box._t);
    box._t = setTimeout(() => { box.hidden = true; }, 6000);
  }
  function wisCartMelding() {
    const box = $("[data-cart-melding]");
    if (box) { box.hidden = true; clearTimeout(box._t); }
  }

  function cartLineHTML(item, index) {
    const img = item.image
      ? `<img src="${item.image.replace(/(\.[a-z]+)(\?|$)/, "_160x200_crop_center$1$2")}" alt="" loading="lazy">`
      : `<div class="ph" data-glyph="⌂" style="position:absolute;inset:0"></div>`;
    const variant = item.variant_title && item.variant_title !== "Default Title"
      ? `<div class="label" style="margin-top:5px">${item.variant_title}</div>` : "";
    return `<div class="cart-line">
      <a class="thumb" href="${item.url}" style="position:relative;display:block">${img}</a>
      <div><a class="cl-titel" href="${item.url}">${item.product_title}</a>
        ${variant}
        <div class="cl-qty">
          <button data-line-dec="${index + 1}" aria-label="Minder">−</button>
          <span>${item.quantity}</span>
          <button data-line-inc="${index + 1}" data-qty="${item.quantity}" aria-label="Meer">+</button>
        </div></div>
      <div style="text-align:right"><div class="font-display" style="font-size:17px">${money(item.final_line_price)}</div>
        <button data-line-rm="${index + 1}" style="border:0;background:none;cursor:pointer;font-family:var(--font-mono);font-size:10px;letter-spacing:.06em;text-transform:uppercase;color:var(--color-ink-3);margin-top:8px">Verwijder</button></div>
    </div>`;
  }

  function renderCart(cart) {
    cartNu = cart;
    // De productpagina hangt zijn voorraadregel hieraan op: die moet
    // opnieuw rekenen zodra het mandje verandert.
    document.dispatchEvent(new CustomEvent("ld:cart", { detail: cart }));
    $$("[data-cart-count]").forEach((b) => {
      b.textContent = cart.item_count;
      b.style.display = cart.item_count ? "grid" : "none";
    });
    const body = $("[data-cart-body]"), foot = $("[data-cart-foot]");
    if (!body || !foot) return;
    if (!cart.items.length) {
      body.innerHTML = `<div style="text-align:center;padding:60px 10px;color:var(--color-ink-3)">
        <div class="ph" data-glyph="❄" style="width:90px;height:90px;border-radius:50%;margin:0 auto 18px"></div>
        <p style="color:var(--color-ink-2)">Je mandje is nog leeg.<br>Tijd om een dorp te bouwen.</p>
        <a class="btn btn-ghost btn-sm" style="margin-top:16px" href="${LD.routes?.all_products_collection_url || "/collections/all"}">Naar de shop</a></div>`;
      foot.innerHTML = "";
      return;
    }
    body.innerHTML = cart.items.map(cartLineHTML).join("");
    const threshold = LD.freeShippingThresholdCents || 0;
    const total = cart.total_price;
    const left = Math.max(0, threshold - total);
    let shipping = "";
    if (threshold > 0) {
      shipping = left > 0
        ? `<div style="font-size:12.5px;color:var(--color-ink-2);margin-bottom:10px">Nog <b style="color:var(--color-teal-deep)">${money(left)}</b> tot gratis verzending</div>
           <div style="height:6px;border-radius:999px;background:var(--color-paper-2);overflow:hidden;margin-bottom:16px"><div style="height:100%;width:${Math.min(100, (total / threshold) * 100)}%;background:var(--color-teal);transition:width .3s"></div></div>`
        : `<div style="font-size:12.5px;color:var(--color-teal-deep);margin-bottom:16px">✓ Je bestelling wordt gratis verzonden</div>`;
    }
    foot.innerHTML = `${shipping}
      <div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:16px">
        <span class="label">Subtotaal</span><span class="font-display" style="font-size:26px">${money(total)}</span></div>
      <a class="btn btn-primary btn-block btn-lg" href="${LD.routes?.cart_url || "/cart"}/checkout">Afrekenen</a>
      <button class="btn btn-ghost btn-block" style="margin-top:8px" data-cart-close>Verder winkelen</button>`;
  }

  async function refreshCart() { renderCart(await fetchCart()); }

  function flash(btn) {
    const orig = btn.innerHTML;
    const isIcon = btn.classList.contains("cart-btn");
    btn.innerHTML = isIcon
      ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M5 13l4 4 10-10" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      : "✓ Toegevoegd";
    btn.disabled = true;
    setTimeout(() => {
      btn.innerHTML = orig;
      btn.disabled = false;
      // Laat de voorraadregel opnieuw beslissen: ligt de hele voorraad nu in
      // het mandje, dan hoort de knop uit te blijven staan.
      document.dispatchEvent(new CustomEvent("ld:cart", { detail: cartNu }));
    }, 1300);
  }

  /* ── Zoek-overlay (predictive search) ─────────────────────────── */
  function openSearch() {
    const ov = $("[data-search-overlay]");
    if (!ov) return;
    closeCart();
    $("[data-mobile]")?.classList.remove("show");
    showScrim(false);
    ov.classList.add("show");
    renderSearchEmpty();
    const inp = $("[data-search-input]");
    setTimeout(() => { if (inp) { inp.value = ""; inp.focus(); } }, 30);
  }
  function closeSearch() { $("[data-search-overlay]")?.classList.remove("show"); }

  function renderSearchEmpty() {
    const host = $("[data-search-results]");
    if (!host) return;
    host.innerHTML = `<div class="search-empty" style="grid-column:1/-1">Typ om te zoeken naar huisjes, dorpen, figuren…</div>`;
  }

  let searchTimer;
  async function runSearch(q) {
    const host = $("[data-search-results]");
    if (!host) return;
    q = (q || "").trim();
    if (!q) { renderSearchEmpty(); return; }
    try {
      const url = `${LD.routes?.predictive_search_url || "/search/suggest"}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,article,query&resources[limit]=4`;
      const res = await fetch(url);
      const data = await res.json();
      const r = data.resources.results;
      const suggs = (r.queries || []).map((s) =>
        `<button class="search-sugg" data-sugg="${s.text}"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3" stroke-linecap="round"/></svg><span>${s.styled_text}</span></button>`).join("")
        || `<div class="search-empty">Geen suggesties</div>`;
      const prods = (r.products || []).length
        ? `<div class="search-prods">${r.products.map((p) => `<a class="search-prod" href="${p.url}"><div class="thumb">${p.featured_image?.url ? `<img src="${p.featured_image.url}" alt="" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover">` : '<div class="ph" data-glyph="⌂"></div>'}</div><div><div class="cat">${p.vendor || ""}</div><div class="nm">${p.title}</div><div class="pr">${p.price ? money(Math.round(parseFloat(p.price) * 100)) : ""}</div></div></a>`).join("")}</div>`
        : `<div class="search-empty">Geen producten gevonden</div>`;
      const cols = (r.collections || []).length
        ? `<div class="search-rows">${r.collections.map((c) => `<a class="search-row" href="${c.url}"><div class="thumb"><div class="ph" data-glyph="⌂"></div></div><span class="nm">${c.title}</span></a>`).join("")}</div>`
        : `<div class="search-empty">Geen collecties</div>`;
      const arts = (r.articles || []).length
        ? `<div class="search-rows">${r.articles.map((a) => `<a class="search-row" href="${a.url}"><div class="thumb"><div class="ph paper" data-glyph="✎"></div></div><span class="nm">${a.title}</span></a>`).join("")}</div>`
        : `<div class="search-empty">Geen artikelen</div>`;
      host.innerHTML = `
        <div><h5 class="search-col-h">Suggesties</h5><div class="search-suggs">${suggs}</div></div>
        <div>
          <div class="search-sec"><h5 class="search-col-h">Producten</h5>${prods}</div>
          <div class="search-sec"><h5 class="search-col-h">Collecties</h5>${cols}</div>
          <div class="search-sec"><h5 class="search-col-h">Artikelen</h5>${arts}</div>
          <div class="search-foot"><a class="btn btn-ghost btn-sm" href="${LD.routes?.search_url || "/search"}?q=${encodeURIComponent(q)}">Bekijk alle resultaten voor “${q}” →</a></div>
        </div>`;
    } catch {
      host.innerHTML = `<div class="search-empty" style="grid-column:1/-1">Zoeken is even niet beschikbaar.</div>`;
    }
  }

  /* ── Recent bekeken (localStorage) ────────────────────────────── */
  const RV_KEY = "ld_recent";
  function getRecent() { try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch { return []; } }
  function pushRecent(item) {
    if (!item || !item.handle) return;
    let r = getRecent().filter((x) => x.handle !== item.handle);
    r.unshift(item);
    localStorage.setItem(RV_KEY, JSON.stringify(r.slice(0, 10)));
  }
  function renderRecent() {
    $$("[data-recent]").forEach((host) => {
      const exclude = host.getAttribute("data-exclude");
      const list = getRecent().filter((p) => p.handle !== exclude).slice(0, 6);
      const section = host.closest(".section, section");
      if (!list.length) { if (section) section.style.display = "none"; return; }
      host.innerHTML = `<div class="rail">${list.map((p) => `<a class="pcard" href="${p.url}" style="text-decoration:none">
        <div class="media">${p.image ? `<img src="${p.image}" alt="" loading="lazy" style="position:absolute;inset:0;width:100%;height:100%;object-fit:contain;padding:10%">` : '<div class="ph" data-glyph="⌂"></div>'}</div>
        <div class="info"><div class="cat">${p.cat || ""}</div><span class="nm">${p.title}</span>
        <div class="priceline"><span class="price">${money(p.price)}</span></div></div></a>`).join("")}</div>`;
      initRails(host);
    });
  }

  /* ── Rails (horizontale productstroken) ──────────────────────────
     De strook scrollt van zichzelf, maar met een muis kun je hem niet
     verschuiven: hij leest dan als een slider die stuk is. Deze functie
     hangt om elke .rail een wrapper met twee pijlen.

     De pijlen mikken op de kaartrand en niet op een vast aantal pixels:
     zo eindigt een klik nooit met een kaart die half over de rand hangt,
     en klopt het met de scroll-snap die de rail al heeft. Rails die door
     JS worden gerenderd (recent bekeken) komen hier ook langs, daarom is
     dit idempotent — een tweede aanroep laat een klaargezette rail staan.
                                                                        */
  const RAIL_PIJL = (kant) =>
    `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="${kant < 0 ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7"}" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

  function initRails(root = document) {
    $$(".rail", root).forEach(bouwRail);
  }

  function bouwRail(rail) {
    if (rail.dataset.railKlaar) return;
    rail.dataset.railKlaar = "1";

    const wrap = document.createElement("div");
    wrap.className = "rail-wrap";
    rail.parentNode.insertBefore(wrap, rail);
    wrap.appendChild(rail);

    const knop = (kant, label, klasse) => {
      const b = document.createElement("button");
      b.type = "button";
      b.className = "rail-nav rail-nav--" + klasse;
      b.setAttribute("aria-label", label);
      b.innerHTML = RAIL_PIJL(kant);
      b.addEventListener("click", () => stapRail(rail, kant));
      wrap.appendChild(b);
      return b;
    };
    const vorige = knop(-1, "Vorige items", "vorige");
    const volgende = knop(1, "Volgende items", "volgende");
    sleepRail(rail);

    function sync() {
      // 4px marge: sub-pixelbreedtes maken scrollWidth net iets groter dan
      // clientWidth terwijl er niets te scrollen valt.
      const ruimte = rail.scrollWidth - rail.clientWidth;
      wrap.classList.toggle("rail-wrap--nav", ruimte > 4);
      vorige.disabled = rail.scrollLeft <= 2;
      volgende.disabled = rail.scrollLeft >= ruimte - 2;
      // Op het midden van de foto en niet van de hele kaart: gecentreerd over
      // kaarthoogte inclusief titel en prijs komt de pijl onder de foto uit
      // en zweeft hij over de productnaam.
      const media = rail.querySelector(".media");
      if (media) wrap.style.setProperty("--rail-mid", Math.round(media.offsetHeight / 2) + "px");
    }
    rail.addEventListener("scroll", sync, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(sync).observe(rail);
    else window.addEventListener("resize", sync);
    // Lazy-loaded foto's veranderen de kaarthoogte, niet de breedte, maar
    // een webfont die later landt wel: nog één keer meten als alles staat.
    window.addEventListener("load", sync);
    sync();
  }

  /* Slepen met de muis. Dat is wat je op een desktop als eerste probeert, en
     zonder dit blijft de strook aanvoelen als een plaatje.

     Twee dingen maken of breken het. Een sleep die op een kaart eindigt mag
     geen klik op die kaart worden — anders open je een product dat je alleen
     voorbij schoof; vandaar de drempel van 5px en het afvangen van de klik
     erna. En scroll-snap moet tijdens het slepen uit: met "mandatory" springt
     de strook bij elke wijziging van scrollLeft terug naar het dichtstbij-
     zijnde snappunt en komt hij niet van zijn plek. Bij het loslaten gaat
     snap weer aan, wat de strook netjes op een kaartrand laat uitkomen.

     Aanraken en pen laten we aan de browser: daar werkt vegen al native, en
     een eigen sleep zou dat dubbel doen.                                    */
  function sleepRail(rail) {
    let bezig = false, gesleept = false, startX = 0, startScroll = 0, pid = null;

    rail.addEventListener("pointerdown", (e) => {
      if (e.pointerType !== "mouse" || e.button !== 0) return;
      // Niet vanaf een bedieningselement: de snel-toevoegen-knop in een kaart
      // moet een knop blijven.
      if (e.target.closest("button, input, select, textarea")) return;
      bezig = true;
      gesleept = false;
      startX = e.clientX;
      startScroll = rail.scrollLeft;
      pid = e.pointerId;
    });

    rail.addEventListener("pointermove", (e) => {
      if (!bezig || e.pointerId !== pid) return;
      const dx = e.clientX - startX;
      if (!gesleept) {
        // Een klik met een trillende hand blijft een klik.
        if (Math.abs(dx) < 5) return;
        gesleept = true;
        rail.classList.add("rail--sleept");
        rail.style.scrollSnapType = "none";
        // Zonder dit blijft de tekst die je bij het indrukken raakte
        // geselecteerd staan en sleep je een blauw blok mee.
        window.getSelection()?.removeAllRanges();
        try { rail.setPointerCapture(pid); } catch { /* niet erg */ }
      }
      rail.scrollLeft = startScroll - dx;
    });

    function stop(e) {
      if (!bezig || (e && e.pointerId !== pid)) return;
      bezig = false;
      if (gesleept) {
        rail.classList.remove("rail--sleept");
        rail.style.scrollSnapType = "";
        try { rail.releasePointerCapture(pid); } catch { /* niet erg */ }
      }
      pid = null;
    }
    rail.addEventListener("pointerup", stop);
    rail.addEventListener("pointercancel", stop);

    // In de capture-fase, dus vóór de link zijn eigen klik krijgt.
    rail.addEventListener("click", (e) => {
      if (!gesleept) return;
      e.preventDefault();
      e.stopPropagation();
      gesleept = false;
    }, true);

    // Foto's en links starten anders halverwege een native drag-and-drop.
    rail.addEventListener("dragstart", (e) => { if (bezig) e.preventDefault(); });
  }

  function stapRail(rail, richting) {
    const kaarten = Array.from(rail.children);
    if (!kaarten.length) return;
    const railLinks = rail.getBoundingClientRect().left;
    // Positie van elke kaart binnen de scroll-inhoud, los van waar de rail
    // zelf op de pagina staat.
    const posities = kaarten.map((k) => Math.round(k.getBoundingClientRect().left - railLinks + rail.scrollLeft));
    const doel = rail.scrollLeft + richting * rail.clientWidth * 0.85;
    // Uitlijnen op de dichtstbijzijnde kaartrand; het einde van de strook
    // mag verder dan de laatste kaartrand, anders blijft de rechterpijl
    // actief terwijl er niets meer komt.
    const max = rail.scrollWidth - rail.clientWidth;
    let beste = posities.reduce((a, b) => (Math.abs(b - doel) < Math.abs(a - doel) ? b : a), posities[0]);
    if (doel >= max - 2) beste = max;
    if (doel <= 2) beste = 0;
    // Een klik moet altijd bewegen: rondt de berekening op de huidige
    // stand uit, pak dan de volgende kaart in de looprichting.
    if (Math.abs(beste - rail.scrollLeft) < 2) {
      const volgende = richting > 0
        ? posities.find((p) => p > rail.scrollLeft + 2)
        : posities.filter((p) => p < rail.scrollLeft - 2).pop();
      beste = volgende === undefined ? (richting > 0 ? max : 0) : volgende;
    }
    const zacht = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    rail.scrollTo({ left: Math.max(0, Math.min(max, beste)), behavior: zacht ? "smooth" : "auto" });
  }

  /* ── Nieuwsbrief: eigen formulier, inschrijving naar Klaviyo ───── */
  function initNewsletter() {
    $$("[data-klaviyo-form]").forEach((form) => {
      const company = form.dataset.company;
      const list = form.dataset.list;
      if (!company || !list) return;
      const fields = form.querySelector(".nl-fields");
      const okBox = form.querySelector("[data-nl-success]");
      const errBox = form.querySelector("[data-nl-error]");
      const btn = form.querySelector("[data-nl-submit]");
      const emailInput = form.querySelector('input[type="email"]');

      function fail(msg) {
        if (!errBox) return;
        errBox.textContent = msg;
        errBox.hidden = false;
      }

      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        if (errBox) errBox.hidden = true;
        const email = (emailInput?.value || "").trim();
        // Alleen een grove vorm-check; Klaviyo valideert zelf ook.
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          fail("Vul een geldig e-mailadres in.");
          emailInput?.focus();
          return;
        }
        const first = (form.querySelector('input[name="first_name"]')?.value || "").trim();
        const label = btn ? btn.textContent : "";
        if (btn) { btn.disabled = true; btn.textContent = "Even geduld…"; }

        const attrs = { email: email, subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } } };
        if (first) attrs.first_name = first;

        try {
          const res = await fetch(
            "https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(company),
            {
              method: "POST",
              headers: { "content-type": "application/json", revision: "2024-10-15" },
              body: JSON.stringify({
                data: {
                  type: "subscription",
                  attributes: {
                    custom_source: form.dataset.source || "Website",
                    profile: { data: { type: "profile", attributes: attrs } },
                  },
                  relationships: { list: { data: { type: "list", id: list } } },
                },
              }),
            }
          );
          // De API antwoordt met 202 Accepted en een lege body.
          if (!res.ok) throw new Error("status " + res.status);
          if (fields) fields.hidden = true;
          if (okBox) okBox.hidden = false;
        } catch (err) {
          if (btn) { btn.disabled = false; btn.textContent = label; }
          fail("Inschrijven lukte niet. Probeer het later opnieuw.");
        }
      });
    });
  }

  /* ── PDP: galerij, varianten, qty ─────────────────────────────── */
  function initProduct() {
    const root = $("[data-product-root]");
    if (!root) return;

    // galerij
    const mainImgs = $$("[data-main-media]", root);
    $$("[data-thumb]", root).forEach((th) => th.addEventListener("click", () => {
      $$("[data-thumb]", root).forEach((x) => x.classList.remove("sel"));
      th.classList.add("sel");
      const id = th.getAttribute("data-media-id");
      mainImgs.forEach((m) => {
        const on = m.getAttribute("data-media-id") === id;
        m.classList.toggle("sel", on);
        // Een verborgen video blijft anders doorspelen: geluid uit een dichtgeklikte slide.
        if (!on) m.querySelectorAll("video").forEach((v) => v.pause());
      });
    }));

    // varianten
    const dataEl = $("[data-product-json]", root);
    const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    const idInput = $('input[name="id"]', root);
    const priceNow = $("[data-price-now]", root);
    const priceOld = $("[data-price-old]", root);
    const addBtn = $("[data-add-btn]", root);
    const stock = $("[data-stock]", root);
    // Het artikelnummer staat op twee plekken (pill bij het merk en de eerste
    // rij van de specificatietabel) en hoort op beide bij de gekozen variant.
    const skuUit = $$("[data-sku-uit]", root);
    const skuRijen = $$("[data-sku-rij]", root);

    function selectedOptions() {
      return $$("[data-variant-group]", root).map((g) => $(".swatch.sel", g)?.dataset.val);
    }
    function syncVariant() {
      const opts = selectedOptions();
      const v = variants.find((x) => opts.every((o, i) => !o || x.options[i] === o));
      $$("[data-variant-group]", root).forEach((g, i) => {
        const out = $("[data-variant-value]", g);
        if (out) out.textContent = opts[i] || "";
      });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = money(v.price);
      skuUit.forEach((el) => { el.textContent = v.sku || ""; });
      // Zonder artikelnummer verdwijnt de hele regel: een label met een leeg
      // vakje ernaast leest als een fout in de data.
      skuRijen.forEach((el) => { el.hidden = !v.sku; });
      if (priceOld) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceOld.textContent = money(v.compare_at_price);
          priceOld.style.display = "";
        } else priceOld.style.display = "none";
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        // De voorraadregel hieronder mag de knop weer aanzetten, maar nooit
        // voor een variant die überhaupt uitverkocht is.
        if (v.available) delete addBtn.dataset.uitverkocht;
        else addBtn.dataset.uitverkocht = "1";
        // Alleen de labelspan: addBtn.textContent zou het slee-icoon wissen.
        const addLabel = $("[data-add-label]", addBtn) || addBtn;
        addLabel.textContent = v.available ? (addBtn.dataset.labelAdd || "In winkelwagen") : (addBtn.dataset.labelSold || "Uitverkocht");
      }
      // Een andere variant kan een andere voorraad hebben: de teller opnieuw
      // aftoppen en de regel eronder bijwerken.
      setQ(parseInt(qtyInput?.value || "1", 10));
      // Moet gelijk blijven aan de servermarkup in main-product.liquid:
      // wijkt dit af, dan verspringt de regel zodra iemand van variant
      // wisselt.
      if (stock) stock.innerHTML = v.available
        ? `<span class="stock-dot"></span> <b>Op voorraad</b> · ${LD.stockNote || "snel geleverd"}`
        : `<span class="stock-dot out"></span> <b>Tijdelijk uitverkocht</b>`;
    }
    $$("[data-variant-group] .swatch", root).forEach((s) => s.addEventListener("click", (e) => {
      e.preventDefault();
      if (s.classList.contains("disabled")) return;
      const group = s.closest("[data-variant-group]");
      $$(".swatch", group).forEach((x) => x.classList.remove("sel"));
      s.classList.add("sel");
      syncVariant();
    }));

    /* qty ─────────────────────────────────────────────────────────
       De teller mag niet boven de voorraad uitkomen, en al wat in het
       mandje ligt gaat van die ruimte af: vijf op voorraad met twee in de
       winkelwagen laat hier nog drie toe. Zonder deze grens weigert
       Shopify de hele toevoeging en gebeurt er bij het klikken niets. */
    const qv = $("[data-qty-val]", root);
    const qtyInput = $('input[name="quantity"]', root);
    const qtyNote = $("[data-qty-note]", root);
    const limietEl = $("[data-variant-limits]", root);
    let limieten = {};
    try { limieten = limietEl ? JSON.parse(limietEl.textContent) : {}; } catch { limieten = {}; }

    function huidigeVariantId() {
      return parseInt(idInput?.value || "0", 10);
    }
    // null = geen grens (variant zonder voorraadbeheer of met doorverkoop).
    function ruimteVoorVariant() {
      const id = huidigeVariantId();
      const voorraad = limieten[String(id)];
      if (voorraad === null || voorraad === undefined) return null;
      return Math.max(0, voorraad - aantalInCart(id));
    }

    function zetNote(tekst) {
      if (!qtyNote) return;
      qtyNote.textContent = tekst || "";
      qtyNote.hidden = !tekst;
    }

    function setQ(n) {
      const ruimte = ruimteVoorVariant();
      n = Math.max(1, n);
      if (ruimte !== null && n > ruimte) n = Math.max(1, ruimte);
      if (qv) qv.textContent = n;
      if (qtyInput) qtyInput.value = n;
      toonRuimte();
      return n;
    }

    // De regel onder de knop hoort alleen te verschijnen als er iets te
    // melden is: bij 47 op voorraad en 2 in de teller is "nog 47" ruis. Dus
    // pas als de teller tegen de grens aan komt, of als de voorraad zelf
    // klein is.
    function toonRuimte() {
      const ruimte = ruimteVoorVariant();
      const inMandje = aantalInCart(huidigeVariantId());
      if (ruimte === null) { zetNote(""); return; }
      if (ruimte === 0) {
        zetNote(inMandje > 0
          ? `Alles wat op voorraad is (${inMandje}) ligt al in je winkelwagen.`
          : "Dit artikel is niet meer op voorraad.");
        if (addBtn) addBtn.disabled = true;
        return;
      }
      if (addBtn && !addBtn.dataset.uitverkocht) addBtn.disabled = false;
      const teller = parseInt(qtyInput?.value || "1", 10);
      if (teller >= ruimte || ruimte <= 5) {
        zetNote(inMandje > 0
          ? `Nog ${ruimte} te bestellen — je hebt er al ${inMandje} in je winkelwagen.`
          : `Nog ${ruimte} op voorraad.`);
      } else {
        zetNote("");
      }
    }

    $("[data-qty-dec]", root)?.addEventListener("click", () => setQ(parseInt(qtyInput?.value || "1", 10) - 1));
    $("[data-qty-inc]", root)?.addEventListener("click", () => setQ(parseInt(qtyInput?.value || "1", 10) + 1));

    // Het mandje kan in een ander tabblad of via de drawer veranderen; dan
    // klopt de ruimte hier niet meer.
    document.addEventListener("ld:cart", () => { setQ(parseInt(qtyInput?.value || "1", 10)); });
    if (variants.length) syncVariant();
    toonRuimte();

    // form → AJAX add
    const form = $("form[data-product-form]", root);
    if (form) form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const id = parseInt(form.querySelector('input[name="id"]').value, 10);
      // Nog één keer knijpen: tussen het instellen van de teller en het
      // klikken kan er in een ander tabblad iets bij zijn gekomen.
      const qty = setQ(parseInt(form.querySelector('input[name="quantity"]')?.value || "1", 10));
      const ruimte = ruimteVoorVariant();
      if (ruimte === 0) { toonRuimte(); return; }
      try {
        await addToCart([{ id, quantity: qty }]);
        if (addBtn) flash(addBtn);
        toonRuimte();
      } catch (err) {
        if (err.voorraad) {
          toonRuimte();
          meldInCart("Er is minder op voorraad dan je vroeg. In je winkelwagen staat wat er wél kan.");
          openCart();
        } else {
          meldInCart(err.message);
          openCart();
        }
      }
    });

    // recent bekeken bijwerken
    const meta = $("[data-product-meta]", root);
    if (meta) { try { pushRecent(JSON.parse(meta.textContent)); } catch { /* leeg */ } }
  }

  /* ── Accordions / tabs / filtergroepen ────────────────────────── */
  function initAccordions() {
    $$(".acc-head").forEach((h) => h.addEventListener("click", () => {
      const item = h.closest(".acc-item");
      const acc = h.closest(".acc");
      if (acc && acc.hasAttribute("data-single")) $$(".acc-item", acc).forEach((x) => x !== item && x.classList.remove("open"));
      item.classList.toggle("open");
    }));
  }
  function initTabs() {
    $$("[data-tabs]").forEach((t) => {
      const btns = $$(".tab-btn", t), panels = $$(".tab-panel", t);
      btns.forEach((b) => b.addEventListener("click", () => {
        btns.forEach((x) => x.classList.remove("active"));
        panels.forEach((p) => p.classList.toggle("active", p.getAttribute("data-tab-panel") === b.getAttribute("data-tab")));
        b.classList.add("active");
      }));
    });
  }

  /* ── Mega menu ────────────────────────────────────────────────── */
  function initMega() {
    const items = $$(".nav-item");
    let hoverTimer;
    function positionMega(it) {
      const mega = it.querySelector(".mega");
      if (!mega) return;
      // Het paneel hangt gecentreerd onder zijn menu-item, met een vaste
      // duw naar rechts. Twee grenzen houden het op zijn plek: rechts de
      // schermrand, links het begin van het menu — zuiver gecentreerd
      // schuift een breed paneel anders tot onder het logo.
      const NUDGE = 30;
      mega.style.left = "0px";
      let left = (it.offsetWidth - mega.offsetWidth) / 2 + NUDGE;
      mega.style.left = left + "px";
      const r = mega.getBoundingClientRect();
      const vw = document.documentElement.clientWidth;
      const menu = it.closest(".nav-menu");
      const minLeft = menu ? menu.getBoundingClientRect().left : 16;
      if (r.right > vw - 16) left -= r.right - (vw - 16);
      else if (r.left < minLeft) left += minLeft - r.left;
      mega.style.left = left + "px";
    }
    items.forEach((it) => {
      if (!it.querySelector(".mega")) return;
      it.addEventListener("mouseenter", () => { clearTimeout(hoverTimer); items.forEach((x) => x !== it && x.classList.remove("open")); it.classList.add("open"); positionMega(it); });
      it.addEventListener("mouseleave", () => { hoverTimer = setTimeout(() => it.classList.remove("open"), 120); });
      it.querySelector(".nav-link")?.addEventListener("click", (e) => {
        if (window.matchMedia("(hover:none)").matches) {
          e.preventDefault();
          const wasOpen = it.classList.contains("open");
          items.forEach((x) => x.classList.remove("open"));
          if (!wasOpen) { it.classList.add("open"); positionMega(it); }
        }
      });
    });
    window.addEventListener("resize", () => { const open = $(".nav-item.open"); if (open) positionMega(open); });
  }

  /* ── Artikel: leesvoortgang ───────────────────────────────────── */
  function initArticle() {
    const bar = $("[data-progress] i");
    if (!bar) return;
    function onScroll() {
      const doc = document.documentElement;
      const max = doc.scrollHeight - doc.clientHeight;
      bar.style.width = (max > 0 ? (doc.scrollTop / max) * 100 : 0) + "%";
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ── Globale klik-afhandeling ─────────────────────────────────── */
  function initClicks() {
    document.addEventListener("click", async (e) => {
      const t = e.target;
      if (t.closest("[data-cart-open]")) { e.preventDefault(); openCart(); }
      if (t.closest("[data-cart-close]")) closeCart();
      if (t.closest("[data-search-open]")) { e.preventDefault(); openSearch(); }
      if (t.closest("[data-search-close]")) closeSearch();
      if (t.closest("[data-menu-open]")) { $("[data-mobile]")?.classList.add("show"); showScrim(true); }
      if (t.closest("[data-menu-close]")) { $("[data-mobile]")?.classList.remove("show"); showScrim(false); }
      if (t.closest("[data-scrim]")) { closeCart(); $("[data-mobile]")?.classList.remove("show"); toggleFilters(false); showScrim(false); }
      const macc = t.closest("[data-macc]");
      if (macc) macc.closest(".m-acc")?.classList.toggle("open");
      const sg = t.closest("[data-sugg]");
      if (sg) { const inp = $("[data-search-input]"); if (inp) inp.value = sg.dataset.sugg; runSearch(sg.dataset.sugg); }
      if (t.closest("[data-filter-toggle]")) toggleFilters();
      const gh = t.closest("[data-fgroup]");
      if (gh) gh.closest(".fgroup")?.classList.toggle("collapsed");

      // cart drawer regels
      const inc = t.closest("[data-line-inc]"), dec = t.closest("[data-line-dec]"), rm = t.closest("[data-line-rm]");
      if (inc) changeLine(parseInt(inc.dataset.lineInc, 10), parseInt(inc.dataset.qty, 10) + 1);
      if (dec) {
        const line = parseInt(dec.dataset.lineDec, 10);
        const qty = parseInt(dec.parentElement.querySelector("span").textContent, 10) - 1;
        changeLine(line, Math.max(0, qty));
      }
      if (rm) changeLine(parseInt(rm.dataset.lineRm, 10), 0);

      // snel toevoegen (productkaarten + bundels)
      const add = t.closest("[data-add-variant]");
      if (add) {
        e.preventDefault();
        const ids = add.dataset.addVariant.split(",").map((x) => parseInt(x.trim(), 10)).filter(Boolean);
        try {
          await addToCart(ids.map((id) => ({ id, quantity: 1 })));
          flash(add);
        } catch (err) {
          openCart();
          meldInCart(err.voorraad
            ? "Er is niet meer van dit artikel op voorraad dan wat er al in je winkelwagen ligt."
            : err.message);
        }
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") { closeCart(); closeSearch(); $("[data-mobile]")?.classList.remove("show"); toggleFilters(false); showScrim(false); }
    });

    const searchInput = $("[data-search-input]");
    if (searchInput) searchInput.addEventListener("input", (e) => {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => runSearch(e.target.value), 220);
    });

    // sorteer-dropdown collectie
    const sortSel = $("[data-sort]");
    if (sortSel) sortSel.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", sortSel.value);
      window.location.href = url.toString();
    });

    // zoeken binnen een lange filterlijst; puur in de browser, zonder submit,
    // zodat je niet bij elke letter de collectie opnieuw laadt
    document.querySelectorAll("[data-fsearch]").forEach((veld) => {
      veld.addEventListener("input", () => {
        const term = veld.value.trim().toLowerCase();
        const opts = veld.closest(".fgroup")?.querySelectorAll(".fopt") || [];
        opts.forEach((opt) => {
          const raakt = !term || opt.textContent.toLowerCase().includes(term);
          // Een aangevinkte waarde blijft staan, anders verdwijnt je eigen
          // selectie zodra je zoekt en submit het formulier hem alsnog mee.
          opt.hidden = !raakt && !opt.querySelector("input")?.checked;
        });
      });
      // enter mag de lijst niet als formulier versturen
      veld.addEventListener("keydown", (e) => { if (e.key === "Enter") e.preventDefault(); });
    });

    // prijsfilter auto-submit bij enter gebeurt native (form)
  }

  /* ── Gerelateerde producten (recommendations) ─────────────────── */
  async function initRecommendations() {
    const host = $("[data-recommendations]");
    if (!host) return;
    const url = `${LD.routes?.product_recommendations_url || "/recommendations/products"}?product_id=${host.dataset.productId}&limit=4&section_id=${host.dataset.sectionId}`;
    try {
      const res = await fetch(url);
      const html = await res.text();
      const div = document.createElement("div");
      div.innerHTML = html;
      const inner = div.querySelector("[data-recommendations]");
      if (inner && inner.innerHTML.trim()) host.innerHTML = inner.innerHTML;
      else host.closest("section")?.style.setProperty("display", "none");
    } catch { host.closest("section")?.style.setProperty("display", "none"); }
  }

  /* ── Lichtsnoer ───────────────────────────────────────────────────
     Hangt de lampjes op de doorhangende draad. getPointAtLength() geeft
     het punt op de kromme, zodat elk lampje de boog volgt in plaats van
     op een rechte lijn te staan.

     De bolletjes worden als HTML-elementen geplaatst, niet als SVG-
     cirkels: de draad-SVG rekt horizontaal mee en zou ze op brede
     schermen tot ovalen uitrekken. De steeltjes staan wél in de SVG —
     verticale lijnen hebben geen last van horizontale schaling.        */
  function initGarland() {
    document.querySelectorAll("[data-garland]").forEach((box) => {
      const svg = $("svg", box);
      const wire = $(".garland-wire", box);
      const stems = $(".garland-stems", box);
      if (!svg || !wire || !stems || stems.childNodes.length) return;

      const NS = "http://www.w3.org/2000/svg";
      const VB_W = 1200;
      const len = wire.getTotalLength();
      const count = 26;

      for (let i = 1; i < count; i++) {
        const pt = wire.getPointAtLength((len * i) / count);

        const stem = document.createElementNS(NS, "line");
        stem.setAttribute("x1", pt.x);
        stem.setAttribute("y1", pt.y);
        stem.setAttribute("x2", pt.x);
        stem.setAttribute("y2", pt.y + 7);
        stem.setAttribute("class", "garland-stem");
        stems.appendChild(stem);

        const bulb = document.createElement("span");
        bulb.className = "garland-bulb garland-bulb--" + (i % 4);
        bulb.style.left = ((pt.x / VB_W) * 100).toFixed(3) + "%";
        bulb.style.top = (pt.y + 10).toFixed(1) + "px";
        bulb.style.animationDelay = (-(i * 0.37) % 3.6).toFixed(2) + "s";
        box.appendChild(bulb);
      }
    });
  }

  /* ── Sneeuwval ────────────────────────────────────────────────────
     Elke vlok krijgt een eigen grootte, valduur, dekking en zijwaartse
     drift. De negatieve animation-delay zet elke vlok op een ander punt
     in zijn val, zodat het bij het laden al sneeuwt in plaats van dat
     alles tegelijk van boven begint.                                   */
  function initSnow() {
    const layer = $("[data-snow]");
    if (!layer || layer.childNodes.length) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const glyphs = ["❄", "❅", "•", "✦"];
    const count = 24;
    let html = "";

    for (let i = 0; i < count; i++) {
      const left = Math.random() * 100;
      const size = 7 + Math.random() * 11;      // 7–18px
      const dur = 11 + Math.random() * 13;      // 11–24s
      const delay = -Math.random() * dur;       // verspreid over de val
      const op = 0.3 + Math.random() * 0.4;     // 0.3–0.7
      const drift = Math.round(Math.random() * 60 - 30); // -30 tot +30px
      const glyph = glyphs[Math.floor(Math.random() * glyphs.length)];

      html +=
        '<span class="flake" style="left:' + left.toFixed(2) + "%;font-size:" +
        size.toFixed(1) + "px;--flake-op:" + op.toFixed(2) + ";--drift:" +
        drift + "px;animation:snow-fall " + dur.toFixed(1) + "s linear " +
        delay.toFixed(1) + 's infinite">' + glyph + "</span>";
    }
    layer.innerHTML = html;
  }

  /* ── Collectie: filters ───────────────────────────────────────────
     Op desktop staat de kolom naast het raster: daar filtert een vinkje
     meteen, zoals altijd. In drawer-modus wacht de pagina op "Toon
     resultaten" — anders herlaadt hij na elk vinkje en slaat het paneel
     dicht, en kun je dus nooit twee filters combineren.

     De knop staat in de Liquid en niet in dit bestand, zodat filteren ook
     werkt als deze JS niet aankomt; dan is die knop de enige manier en
     blijft hij op elke breedte staan.                                   */
  function initFilters() {
    const panel = $("[data-filter-panel]");
    if (!panel) return;
    const applyBtn = $("[data-filter-apply]", panel);
    const drawerModus = () => window.matchMedia("(max-width: 980px)").matches;

    function syncApply() {
      if (applyBtn) applyBtn.hidden = !drawerModus();
    }
    syncApply();
    window.addEventListener("resize", syncApply);

    // Een leeg prijsveld hoort niet in het adres: het filtert niets en zet
    // achter elke filterklik een "?filter.v.price.gte=&filter.v.price.lte="
    // in de URL. Een uitgeschakeld veld stuurt de browser niet mee.
    function laatLegePrijsWeg() {
      $$('input[name^="filter.v.price"]', panel).forEach((veld) => {
        if (!veld.value) veld.disabled = true;
      });
    }
    // De knop levert een submit-event (de formdata wordt daarna pas
    // opgebouwd, dus hier uitschakelen werkt); form.submit() uit code niet,
    // dus die route ruimt zelf op.
    panel.addEventListener("submit", laatLegePrijsWeg);

    panel.addEventListener("change", (e) => {
      if (!(e.target instanceof HTMLInputElement)) return;
      if (e.target.type !== "checkbox") return;
      if (drawerModus()) return;
      laatLegePrijsWeg();
      panel.submit();
    });
  }

  /* ── Terug naar boven ─────────────────────────────────────────── */
  function initNaarBoven() {
    const knop = $("[data-naar-boven]");
    if (!knop) return;
    // Pas hier zichtbaar maken: zonder JS zou de knop dood in de hoek staan.
    knop.hidden = false;

    let zichtbaar = false;
    let vorigeY = window.scrollY;
    function zet(aan) {
      if (aan === zichtbaar) return;
      zichtbaar = aan;
      knop.classList.toggle("show", aan);
    }
    function onScroll() {
      const y = window.scrollY;
      const delta = y - vorigeY;
      // Drempel van 4px, anders knippert de knop bij het minste trillen van
      // een vinger op het glas.
      if (Math.abs(delta) < 4) return;
      vorigeY = y;
      // Binnen driekwart schermhoogte van de bovenkant is die bovenkant nog
      // bijna in zicht en heeft de knop niets toe te voegen.
      if (y < window.innerHeight * 0.75) return zet(false);
      // Alleen op de weg terug omhoog. Naar beneden scrollend zweeft hij
      // precies over de winkelwagenknop rechtsonder in een productkaart, en
      // dan is hij een obstakel in plaats van een uitweg.
      zet(delta < 0);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    knop.addEventListener("click", () => {
      const zacht = !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      window.scrollTo({ top: 0, behavior: zacht ? "smooth" : "auto" });
    });
  }

  /* ── Init ─────────────────────────────────────────────────────── */
  function init() {
    initMega();
    initClicks();
    initAccordions();
    initTabs();
    initProduct();
    initFilters();
    initNaarBoven();
    initNewsletter();
    initArticle();
    initRecommendations();
    renderRecent();
    refreshCart();
    initGarland();
    initSnow();
    initRails();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  window.LDApi = { addToCart, money, refreshCart };
})();
